// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import {Guid} from "guid-typescript";

// AbilityIntranet.Data.Intranet.ActivityQueryDto
export class ActivityQueryDto {
    public customerGuid: Guid = null;
    public caseGuid: Guid = null;
    public activityGuid: Guid = null;
    public userGuid: Guid = null;
    public completed: boolean = null;
    public dueToday: boolean = null;
}


    



